import { ReactNode } from "react";

import { AppBreadcrumbsReplacements } from "./breadcrumbs";

export enum ViewVariant {
  Page = "page",
  Tab = "tab",
  Modal = "modal",
}

export enum EntityViewVariant {
  List = "list",
  View = "view",
  Create = "create",
  Update = "update",
  CreateUpdate = "createUpdate",
  Delete = "delete",
}

export interface IBasePageLayout {
  breadcrumbs?: {
    replacements?: AppBreadcrumbsReplacements;
  };
  header?: ReactNode;
  body?: ReactNode;
  footer?: ReactNode;
  /** Same as body. */
  children?: ReactNode;
}
